import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CustomTextField from "../../../Components/CustomTextField/CustomTextField";
import CustomDropDown from "../../../Components/CustomDropDown/CustomDropDown";
import CustomSubmitButton from "../../../Components/CustomSubmitButton/CustomSubmitButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import Constant from "../../../Utils/Constant";
import CustomDatePicker from "../../../Components/CustomDatePicker/CustomDatePicker";
import { useDispatch } from "react-redux";
import { ADD_NOTIFICATION_ACTION, GET_NOTIFICATION_ACTION } from "../../../Redux/Slices/NotificationSlice/NotificationSlice.action";
import moment from "moment/moment";
import { toast } from "react-toastify";
import BELL_ICON from '../../../Assets/Images/Bell.png';
import Skeleton from "react-loading-skeleton";
const Notifications = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const optionList = [
    {
      id: 1,
      name: "Send Now",
    },
    {
      id: 2,
      name: "Schedule Later",
    },
  ]
  const [notificationList, setNotificationList] = useState([]);
  useEffect(() => {
    getNotification()
  }, [dispatch])
  const getNotification = async () => {
    await dispatch(GET_NOTIFICATION_ACTION()).unwrap()
      .then((res) => {
        if (res && res?.s === 1) {
          const Rowdata = res?.r;
          setIsLoading(false)
          setNotificationList(Rowdata);
        } else {
          setNotificationList([]);
          setIsLoading(false)
        }
      }).catch((error) => {
        console.log('error', error);
        setIsLoading(false)
      })
  }
  const formik = useFormik({
    initialValues: {
      title: "",
      description: "",
      selectOption: "",
      selectDateTime: null,
    },
    validationSchema: Yup.object().shape({
      title: Yup.string()
        .required("Please enter notification title")
        .matches(Constant.REGEX.NAME, "Please enter valid title"),
      description: Yup.string().required("Please enter description here"),
      selectOption: Yup.mixed()
        .test("is-not-zero", "Select option is required", (value) => value !== null)
        .required("Select option is required!"),
      selectDateTime: Yup.mixed()
        .test("date-time-required", "Date and time are required when scheduling later.", function (value) {
          const { selectOption } = this.parent;
          if (selectOption === 2 && !value) {
            return false;
          }
          return true;
        })
        .notRequired(),
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      try {
        const formData = new FormData();
        formData.append("title", values.title);
        formData.append("message", values.description);
        formData.append("notification_type", values.selectOption);
        formData.append("is_store", 1);
        if (values.selectOption === 2) {
          const scheduleDate = moment(values.selectDateTime?.$d)
            .utc()
            .format("YYYY-MM-DD HH:mm:ss");
          formData.append("schedule_time", scheduleDate);
        }
        const response = await dispatch(ADD_NOTIFICATION_ACTION(formData));
        console.log('response===>', response);
        if (response && response?.payload?.s) {

          setIsLoading(false);
          toast.success(response?.payload?.m);
          getNotification();
        } else {
          setIsLoading(false);
          toast.error(response?.payload?.m);
        }
      } catch (error) {
        console.log('error', error);
        toast.error(error);
        setIsLoading(false);
      } finally {
        resetForm();
        setIsLoading(false);
      }
    },
  });
  return (
    <>
      <Box
        sx={{
          width: "100%",
          padding: "15px",
          display: "flex",
          gap: "40px",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={5}>
            <Typography
              sx={{ fontSize: { xs: "25px", md: "30px" }, fontWeight: "500", paddingBottom: '30px', fontFamily: 'Outfit', }}
            >
              Notifications
            </Typography>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
                return false;
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "40px",

                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <CustomTextField
                      label={"Notification Title"}
                      name="title"
                      value={formik.values.title}
                      onKeyUp={formik.handleBlur}
                      onBlur={formik.handleBlur}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value.trimStart() !== value) {
                          e.target.value = value.trimStart();
                        }
                        formik.handleChange(e);
                      }}
                      errors={formik.touched.title && formik.errors.title}
                      sx={{
                        "& .MuiInputBase-root": {
                          borderRadius: "10px",
                          // border: formik.errors.title ? "1px solid red" : "1px solid rgba(8, 85, 127, 0.3)",
                          color: "black",
                          fontSize: "18px",
                          background: "rgba(237, 245, 248, 1)",
                          fontFamily: "Outfit",
                        },
                      }}
                      style={{ color: "black", fontSize: "18px" }}
                      placeholder={"Title"}
                      isLoading={isLoading}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CustomTextField
                      name="description"
                      value={formik.values.description}
                      onKeyUp={formik.handleBlur}
                      onBlur={formik.handleBlur}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value.trimStart() !== value) {
                          e.target.value = value.trimStart();
                        }
                        formik.handleChange(e);
                      }}
                      errors={formik.touched.description && formik.errors.description}
                      label={"Description"}
                      sx={{
                        "& .MuiInputBase-root": {
                          borderRadius: "10px",
                          // border: formik.errors.description ? "1px solid red" : "1px solid rgba(8, 85, 127, 0.3)",
                          color: "black",
                          fontSize: "18px",
                          background: "rgba(237, 245, 248, 1)",
                          fontFamily: "Outfit",
                        },
                      }}
                      style={{ color: "black", fontSize: "18px" }}
                      placeholder={"Description"}
                      multiline={true}
                      rows={5}
                      isLoading={isLoading}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CustomDropDown
                      Title={"Select Option"}
                      value={formik.values.selectOption}
                      onChange={(event) => {
                        formik.setFieldValue("selectOption", event?.target?.value);
                      }}
                      placeholder={'Select Option'}
                      menuList={optionList}
                      NoData='No Option Available'
                      isLoading={isLoading}
                      errors={formik.touched.selectOption && formik.errors.selectOption}
                    />
                  </Grid>
                  {formik?.values?.selectOption !== 1 && <>
                    <Grid item xs={12} md={12}>
                      <Typography
                        sx={{
                          color: "black",
                          fontWeight: "400",
                          textAlign: "left",
                          fontFamily: 'Outfit',
                          fontSize: { xs: "14px", sm: "16px" },
                          mb: '4px'
                        }}
                      >
                        Date and Time
                      </Typography>
                      <CustomDatePicker
                        value={formik.values.selectDateTime}
                        onChange={(newValue) => formik.setFieldValue("selectDateTime", newValue)}
                        error={formik.touched.selectDateTime && formik.errors.selectDateTime}
                        inputFormat="YYYY-MM-DD HH:mm"
                        isLoading={isLoading}
                        sx={{
                          width: "100%",
                          borderRadius: "10px",
                          color: "black",
                          fontSize: "18px",
                          background: "rgba(237, 245, 248, 1)",
                          fontFamily: "Outfit",
                          outline:
                            formik.touched.selectDateTime && formik.errors.selectDateTime
                              ? "red"
                              : "#D0BCFF",
                          ".MuiOutlinedInput-root": {
                            borderRadius: "10px",
                            border: "none",
                          },
                        }}
                      />

                      {formik.touched.selectDateTime && formik.errors.selectDateTime ? (
                        <Typography
                          sx={{
                            color: "red",
                            fontWeight: "400",
                            fontSize: { xs: "14px", sm: "14px" },
                            marginTop: "5px",
                            paddingLeft: "10px",
                          }}
                        >
                          {formik.errors.selectDateTime}
                        </Typography>
                      ) : null}
                    </Grid>
                  </>}
                  <Grid item xs={12} md={6}>
                    <CustomSubmitButton
                      type={"submit"}
                      loading={isLoading}
                      sx={{
                        width: { xs: "70%", md: "50%" },
                        color: "#fff",
                        "&:hover": { color: "#fff" },
                      }}
                      btnTitle={"Send"}
                    />
                  </Grid>
                </Grid>
              </Box>
            </form>
          </Grid>
          <Grid item xs={12} md={7}>
            <Typography sx={{ fontSize: { xs: "25px", md: "30px" }, fontWeight: "500", paddingBottom: '30px' }}>
              Notifications History
            </Typography>
            <Box
              className="scrollBar"
              sx={{
                height: "calc(100vh - 120px)",
                overflowY: "auto",
                padding: '0px 15px'
              }}
            >
              {isLoading ? <Skeleton height={100} count={5} /> : notificationList?.length > 0 ? notificationList.map((item, index) => {
                const timeDifference = moment(item?.created_at).fromNow();
                const createdAt = moment(item?.created_at);

                const isToday = createdAt.isSame(moment(), 'day');
                const isYesterday = createdAt.isSame(moment().subtract(1, 'days'), 'day');
                const isTomorrow = createdAt.isSame(moment().add(1, 'days'), 'day');

                let label = '';
                if (isToday) {
                  label = 'Today';
                } else if (isYesterday) {
                  label = 'Yesterday';
                } else if (isTomorrow) {
                  label = 'Tomorrow';
                }
                return (
                  <>
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: "1rem",
                        mb: 1,
                        p: 2,
                        borderRadius: "12px",
                        bgcolor: "#0097B21A",
                        border: "1px solid rgba(143, 199, 255, 1)",
                      }}
                    >
                      <Box sx={{
                        backgroundColor: '#fff',
                        width: '38px',
                        height: '38px',
                        borderRadius: '10px'
                      }}>
                        <img src={BELL_ICON} alt="bell" style={{
                          width: '100%'
                        }} />
                      </Box>
                      <Box sx={{
                        width: "calc(100% - 38px)"
                      }}>
                        <Box sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between'
                        }}>
                          <Typography sx={{ fontWeight: "500", fontFamily: 'Outfit', fontSize: '18px' }}>
                            {item?.title || "N/A"}
                          </Typography>
                          <Typography sx={{ fontWeight: "400", fontSize: '12px', fontFamily: 'Outfit' }}>
                            {timeDifference === "an hour ago" ? (
                              <span style={{ color: 'blue' }}>Sent 1 hour ago</span>
                            ) : (
                              timeDifference
                            )}
                          </Typography>
                        </Box>
                        <Typography sx={{ color: "#2B2B2B", fontFamily: 'Outfit', fontSize: '16px', fontWeight: '400' }}>
                          {item?.message || "N/A"}
                        </Typography>
                        <Box sx={{
                          mt: 2,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          color: item?.status === 1 ? "green" : "orange"
                        }}>
                          <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                            {item?.status === 1 ? "" : "Pending"}
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </>
                )
              }) : null}
            </Box>
          </Grid>
        </Grid>


      </Box>
    </>

  );
};

export default Notifications;
